<template>
  <div class="page">
    <ion-grid>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="2">
              <ion-label>Station Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="name"
                  @input="name = $event.target.value"
                  maxlength="50"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Address</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="city"
                  @input="city = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>From</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  input-class="form-vue-picker"
                  placeholder="DD/MON/YYYY"
                  format="dd/MMM/yyyy"
                  v-model="effectiveFrom"
                  :typeable="true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <div class="input-icon-calendar">
                  <ion-datetime
                    class="form-picker"
                    placeholder="Select From Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="effectiveFrom = $event.target.value"
                  ></ion-datetime>
                </div>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>To</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  input-class="form-vue-picker"
                  placeholder="DD/MON/YYYY"
                  format="dd/MMM/yyyy"
                  v-model="effectiveTo"
                  :typeable="true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <div class="input-icon-calendar">
                  <ion-datetime
                    class="form-picker"
                    placeholder="Select To Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="effectiveTo = $event.target.value"
                  ></ion-datetime>
                </div>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>
                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchStations">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields"><ion-icon :icon= "refresh"></ion-icon></ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
            <ion-col size="12" size-md="1">
              <ion-label>Station ID</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Station Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>City</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Effective From</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Last Effective Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />
          <ion-row class="list-item" v-for="(station) in this.stations" :key="station">
            <ion-col size="12" size-md="1">
              <ion-label class="ext-link" @click="viewStation(station.id)">{{station.id}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>{{station.name}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{station.address.city}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{changeDateFormatWithoutTime(station.effectiveOn)}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{changeDateFormatWithoutTime(station.effectiveTill)}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label
                v-bind:class="[{'active': station.status.id == 'A'}, {'greenfield': station.status.id == 'G'}, {'in-active': station.status.id == 'I'}, {'extinct': station.status.id == 'X'}]"
              >{{convertUppercase(station.status.name)}}</ion-label>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" text-center>
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" text-right>
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner,modalController } from "@ionic/vue";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVCStation, EVCStationStatus } from "../../entity/location/evcstation";

import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { refresh } from 'ionicons/icons';
import moment from "moment";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
  name: 'chargingStations',
  components: {
    datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonSpinner,
    modalController
  },
  data() {
    return {
      refresh,
      loaderTab: true,
      stations: null,
      statuses: [],
      statusModels: [],
      id: "",
      name: "",
      city: "",
      effectiveFrom: "",
      effectiveTo: "",
      status: "",

      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 10,
      pageNo: 1,
      pagesList: [],
      totalPages: 0
    }
  },
  async mounted() {
    try {
      this.statuses = await new EVCStationService().stationStatuses();
      this.statusModels = [];
      this.statuses.forEach(status => {
      this.statusModels.push({
        text: status.name,
        value: status.id
      });
      });
      var search = localStorage.getItem('stationSearch');
      if (search!=null) {
        search = JSON.parse(search);
        this.name = search.name;
        this.city = search.city;
        document.getElementById("name").value = search.name;
        document.getElementById("city").value = search.city;
        this.effectiveFrom = search.effectiveFrom;
        this.effectiveTo = search.effectiveTo;
        this.status = search.status;
      }
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    viewStation(stationId) {
      modalController.dismiss(stationId)
    },
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    changeDateFormatWithoutTime(dateValue) {
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
    },
    convertUppercase(value) {
      return value.toUpperCase()
    },
    addStation() {
      this.$router.push("/admin/chargingstations/station");
    },
    clearFields() {
      this.name = null;
      this.city = null;
      document.getElementById("name").value = null;
      document.getElementById("city").value = null;
      this.effectiveFrom = null;
      this.effectiveTo = null;
      this.status = null;

      localStorage.setItem('stationSearch', null);
    },
    async searchStations() {
      try {
        localStorage.setItem('stationSearch', JSON.stringify({name: this.name, city: this.city, effectiveFrom: this.effectiveFrom, effectiveTo: this.effectiveTo, status: this.status }));
        if ((this.effectiveFrom && this.effectiveTo) && (new Date(this.effectiveFrom) > new Date(this.effectiveTo))) {
          new ToastUtils().presentToast("Please select correct date range. From date should less than To date");
          this.stations = [];
        } else {
          this.loaderTab = true;
          let result = await new EVCStationService().stationsAtPageByPaginatedWithSizeMatchingQuery(
          1,
          this.pageRecords,
          {
              id: this.id,
              name: this.name,
              city: this.city,
              effectiveBetween: {
              from: this.effectiveFrom ? new Date(this.effectiveFrom) : null,
              to: this.effectiveTo ? new Date(this.effectiveTo) : null
              },
              installationsBetween: {
              min: null,
              max: null
              },
              status: new EVCStationStatus(this.status, "")
          }
          );
          this.totalRecords = result.total;
          this.stations = result.fetched;
          (this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          this.pageNo
          )),
          (this.totalPages = new PaginationUtils().getTotalPages(
              this.totalRecords,
              this.pageRecords
          ));
          this.norecordsfound = false;
          this.loaderTab = false;
          new ToastUtils().presentToast("Search completed");
        } 
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    async loadPage(page) {
      try {
        this.loaderTab = true;
        this.pageNo = page;
        this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          page
        );

        let result = await new EVCStationService().stationsAtPageByPaginatedWithSizeMatchingQuery(
          this.pageNo,
          this.pageRecords,
          {
          id: this.id,
          name: this.name,
          city: this.city,
          effectiveBetween: {
            from: this.effectiveFrom ? new Date(this.effectiveFrom) : null,
            to: this.effectiveTo ? new Date(this.effectiveTo) : null
          },
          installationsBetween: {
            min: null,
            max: null
          },
          status: new EVCStationStatus(this.status, "")
          }
        );
        this.totalRecords = result.total;
        this.stations = result.fetched;
        this.loaderTab = false;
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    }
  }
})
</script>

<style scoped>
.stop-repeating-content {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  overflow: scroll;
}
.select-box {
  position: relative;
  max-width: 317px;
  width: 100%;
  display: inline-block;
  margin-right: 16px;
}

.select-box ion-select {
  max-width: 317px;
  width: 100%;
  height: 34px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 4px;
  opacity: 1;
  padding: 12px;
  padding-top: 13px;
  text-align: left;
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  line-height: 26px;
  color: #202020;
}

.select-box .custom-select-placeholder {
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
  position: absolute;
  z-index: 99;
  top: 18px;
  left: 18px;
}

.select-box .custom-select-icon {
  position: absolute;
  z-index: 99;
  top: 6px;
  background: #fff;
  right: 15px;
}
</style>